export const COLLECTION_OFFERS_TABLE_PAGE_SIZE = 50
export const COLLECTION_OFFERS_SORT = {
  direction: "DESC",
  by: "OFFER_PRICE",
} as const
